/**
 * States in the CF/SF (Combined Federal/State Filing) program, as CFSFElectionStateCd takes them
 * (2-letter abbreviations). This is the TY2025 list (IRIS form rule SHAREDIRFORM019_002).
 * TY2026 drops Oregon (SHAREDIRFORM019_003, IRS release 2026-09-24, and Table 2 of the TY2026
 * IRIS ATS examples); use cfsfStatesForTaxYear for a filing's own year.
 */
export const CFSF_PARTICIPATING_STATES = [
  "AL", // Alabama
  "AZ", // Arizona
  "AR", // Arkansas
  "CA", // California
  "CO", // Colorado
  "CT", // Connecticut
  "DE", // Delaware
  "DC", // District of Columbia
  "GA", // Georgia
  "HI", // Hawaii
  "ID", // Idaho
  "IN", // Indiana
  "KS", // Kansas
  "LA", // Louisiana
  "ME", // Maine
  "MD", // Maryland
  "MA", // Massachusetts
  "MI", // Michigan
  "MN", // Minnesota
  "MS", // Mississippi
  "MT", // Montana
  "NE", // Nebraska
  "NJ", // New Jersey
  "NM", // New Mexico
  "NC", // North Carolina
  "ND", // North Dakota
  "OH", // Ohio
  "OK", // Oklahoma
  "OR", // Oregon
  "PA", // Pennsylvania
  "RI", // Rhode Island
  "SC", // South Carolina
  "WI", // Wisconsin
] as const;

/** States the CF/SF program takes from TY2026 on: the TY2025 list without Oregon. */
const CFSF_STATES_FROM_2026: readonly string[] = CFSF_PARTICIPATING_STATES.filter(
  (state) => state !== "OR"
);

/** The CF/SF participating states for a tax year (the TY2025 list for 2025 and earlier). */
export function cfsfStatesForTaxYear(taxYear?: string | number): readonly string[] {
  return Number(taxYear) >= 2026 ? CFSF_STATES_FROM_2026 : CFSF_PARTICIPATING_STATES;
}

/**
 * Whether a state participates in the CF/SF program in the given tax year.
 * @param stateAbbrev - 2-letter state abbreviation (e.g., "IN", "AL")
 * @param taxYear - the filing's tax year; without it, the TY2025 list applies
 */
export function isCFSFParticipatingState(
  stateAbbrev: string | undefined,
  taxYear?: string | number
): boolean {
  if (!stateAbbrev) return false;
  const upperState = stateAbbrev.toUpperCase().substring(0, 2);
  return cfsfStatesForTaxYear(taxYear).includes(upperState);
}

/*
 * EXTRACTION NOTE: isCombinedFederalStateProgramEnabled(siteId) and getSiteIdFromRecord(record)
 * lived here and queried Postgres ("siteYear".combinedFederal_stateProgram and
 * "customerFiles".site_id). The engine owns no database, so the question moved to the host:
 * ctx.lookups.cfsfEnabled(record). The state table above is IRS reference data and stays.
 */
